import { Component, Input, OnInit } from '@angular/core';
import { FeatureFlagsService } from '../../../Common/FeatureFlags/feature-flags-service';
import { AceLoaderComponent } from '../../../UI-Lib/ACE/Loader/loader.component';
import { AnchorRouteDirective } from '../../../UI-Lib/Directives';
import { PanelChevronComponent } from '../../../UI-Lib/Weissman-Panel/panel.chevron.component';

@Component({
    selector: 'company-compliance',
    templateUrl: './companyCompliance.component.html',
    styleUrls: ['./companyCompliance.component.scss'],
    imports: [PanelChevronComponent, AnchorRouteDirective, AceLoaderComponent],
})
export class CompanyComplianceComponent implements OnInit {
    constructor(private readonly _featureFlagService: FeatureFlagsService) {}

    @Input() company;
    @Input() parentCompany: Core.ParentCompanyDTO;
    @Input() isTopLevelCompany: boolean;

    isShowInfo: boolean = false;
    hasAllocationFeature: boolean = false;

    get isLoading(): boolean {
        return !this.company;
    }

    ngOnInit(): void {
        this.hasAllocationFeature = this._featureFlagService.featureFlags.enableAllocationFeature;
    }

    expandOrCollapse() {
        this.isShowInfo = !this.isShowInfo;
    }
}
